'use strict';
const {
  assign,
  create,
  defineProperties,
  entries,
  getOwnPropertyDescriptors,
  keys,
  setPrototypeOf
} = Object;

exports.assign = assign;
exports.create = create;
exports.defineProperties = defineProperties;
exports.entries = entries;
exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
exports.keys = keys;
exports.setPrototypeOf = setPrototypeOf;
